import React from 'react';
export const ActionBarContext = /*#__PURE__*/ React.createContext('primary');
ActionBarContext.displayName = 'ActionBarContext';
export const SecondaryActionBarContext = /*#__PURE__*/ React.createContext({
    setTopActionBarRef: ()=>null
});
SecondaryActionBarContext.displayName = 'SecondaryActionBarContext';
/**
 * Holds a boolean that tells us if any dialog is shown by our ActionBar controls.
 */ export const ActionBarDialogContext = /*#__PURE__*/ React.createContext(false);

//# sourceMappingURL=ActionBarContext.js.map